export const searchString = (text: string, terms: string) => {
  // Escape all RegExp special characters
  const escapedTerms = terms.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const exp = new RegExp(escapedTerms, 'i');
  return exp.test(text);
};
